import classes from '../styles/Page.module.scss';
import client from './api/graphql';
import { GET_SUPPORT_CONTENT } from './api/graphql/queries';
import ContactUs from '../components/sections/contactUs/ContactUs';

/**
 * Ayoba Support Page
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const Support = (props) => {
    const { homePage } = props?.data;

    /**
     * Section content
     */
    const { contact_us } = homePage?.data?.attributes;

    return (
        <div className={classes.oSupport}>
            <ContactUs {...contact_us} />
        </div>
    );
};

export async function getServerSideProps(context) {
    const locale = context.query?.lang || context.defaultLocale;

    const { data } = await client.query({
        query: GET_SUPPORT_CONTENT,
        variables: { _locale: locale }
    });

    return {
        props: { data }
    };
}

export default Support;
